module.exports = __webpack_public_path__ + "img/Doc01-20040015-007.b55dbd82.jpg";